import { render, staticRenderFns } from "./TelKey.vue?vue&type=template&id=2fb2b3ac&scoped=true&lang=pug&"
import script from "./TelKey.vue?vue&type=script&lang=ts&"
export * from "./TelKey.vue?vue&type=script&lang=ts&"
import style0 from "./TelKey.vue?vue&type=style&index=0&id=2fb2b3ac&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fb2b3ac",
  null
  
)

export default component.exports